import { useEffect, useState } from 'react'
import { errorMessage } from '../../lib/api.js'
import { usePublishDraft } from '../../lib/queries/systems.js'
import { Dialog } from '../ui/Dialog.jsx'
import { useToast } from '../ui/Toast.jsx'

function nextLabel(label) {
  if (!label) return '1.0'
  const parts = label.split('.').map(Number)
  if (parts.some(Number.isNaN)) return ''
  parts[parts.length - 1] += 1
  return parts.join('.')
}

export function PublishDialog({ system, open, onClose }) {
  const publish = usePublishDraft(system.slug)
  const toast = useToast()
  const [label, setLabel] = useState('')
  const [notes, setNotes] = useState('')
  const [error, setError] = useState(null)

  useEffect(() => {
    if (open) {
      setLabel(nextLabel(system.published?.label))
      setNotes('')
      setError(null)
    }
  }, [open, system.published?.label])

  const valid = /^\d+(\.\d+){0,2}$/.test(label)

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={`Publish ${system.name} skill`}
      description="New questions will answer from this version. Earlier answers keep a record of the version they used."
      footer={
        <>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-teal"
            disabled={!valid || publish.isPending}
            onClick={() =>
              publish.mutate(
                { label, notes: notes.trim() || undefined },
                {
                  onSuccess: () => {
                    toast.success(`${system.name} skill v${label} is live`)
                    onClose()
                  },
                  onError: (e) => setError(errorMessage(e)),
                },
              )
            }
          >
            {publish.isPending ? 'Publishing…' : `Publish v${label || '…'}`}
          </button>
        </>
      }
    >
      <label className="field">
        <span>Version</span>
        <input value={label} onChange={(e) => setLabel(e.target.value.trim())} placeholder="1.2" autoFocus />
        {!valid && label ? <small className="field-error">Use a version like 1.2</small> : null}
      </label>
      <label className="field">
        <span>What changed (optional)</span>
        <textarea value={notes} maxLength={1000} onChange={(e) => setNotes(e.target.value)} />
      </label>
      {error ? <span className="field-error">{error}</span> : null}
    </Dialog>
  )
}
